(() => {
  if (window.agProductLayoutReady) return;
  window.agProductLayoutReady = true;
  const setup = (root) => {
    if (root.dataset.agReady) return;
    root.dataset.agReady = 'true';
    const sticky = root.querySelector('[data-ag-sticky]');
    if (!sticky) return;
    const labels = sticky.dataset;
    const info = root.querySelector('.product__info-container');
    const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const category = normalize(root.dataset.agCategory || '');
    const isRing = /inel|verighet/.test(category);
    const canEngrave = isRing || /personaliz|grava/.test(category);
    const button = sticky.querySelector('button');
    const actualButton = () => root.querySelector('.product-form__submit');
    const sync = () => {
      const buy = actualButton();
      if (buy) {
        const disabled = buy.disabled || buy.getAttribute('aria-disabled') === 'true';
        if (button.disabled !== disabled) button.disabled = disabled;
        const text = buy.querySelector('span')?.textContent.trim() || labels.agAdd;
        if (button.textContent !== text) button.textContent = text;
        const stock = root.querySelector('[data-ag-stock="standard"]');
        const stockText = buy.disabled && /epuizat|indisponibil|sold out|unavailable/i.test(text) ? text : stock?.dataset.agAvailable;
        if (stock && stockText && stock.textContent !== stockText) stock.textContent = stockText;
      }
      const price = root.querySelector('.price--on-sale .price-item--sale') || root.querySelector('.price__regular .price-item--regular');
      let value = price?.textContent.trim();
      const charge = root.querySelector('.po-priceSummary-price')?.textContent.trim();
      const parseMoney = (text) => {
        let number = (text || '').replace(/[^0-9.,-]/g, '');
        const decimal = number.match(/[.,](\d{2})$/);
        number = decimal ? number.slice(0, -3).replace(/[.,]/g, '') + '.' + decimal[1] : number.replace(/[.,]/g, '');
        return Number(number);
      };
      if (charge && value) {
        const total = parseMoney(value) + parseMoney(charge);
        if (Number.isFinite(total)) value = new Intl.NumberFormat(document.documentElement.lang || 'ro', {style:'currency',currency:labels.agCurrency}).format(total);
      }
      const summaryText = root.querySelector('.po-priceSummary-summaryText');
      if (summaryText && summaryText.textContent !== labels.agOptionsCharge) summaryText.textContent = labels.agOptionsCharge;
      const priceTarget = sticky.querySelector('[data-ag-sticky-price]');
      if (value && priceTarget.textContent !== value) priceTarget.textContent = value;
      root.querySelectorAll('.po-option-root').forEach(option => {
        const heading = option.querySelector('.po-heading-heading');
        if (heading && /eleganta in fiecare detaliul/i.test(normalize(heading.textContent))) {
          const replacement = document.createElement('p');
          replacement.className = heading.className;
          replacement.textContent = labels.agHeading;
          heading.replaceWith(replacement);
        }
        const size = option.querySelector('input[placeholder="Pentru inele si verighete"]');
        const engraving = option.querySelector('input[placeholder="Text de gravat plus fontul..."]');
        const decorative = option.querySelector('.po-heading-root,.po-divider-root');
        const shouldHide = size || engraving || decorative;
        if (shouldHide && !option.classList.contains('ag-option-hidden')) {
          option.classList.add('ag-option-hidden');
          option.querySelectorAll('input,textarea,select').forEach(input => { input.disabled = true; });
        }
        const field = option.querySelector('input[name="properties[Ambalaje Antonia Gold]"]');
        if (!field) return;
        option.classList.add('ag-packaging-option');
        const grid = option.querySelector('.po-imageSwatches-swatches');
        if (!grid) return;
        grid.querySelectorAll('.po-imageOption-swatchLabel').forEach(swatch => {
          const item = swatch.closest('.po-imageSwatches-optionItem');
          swatch.setAttribute('role', 'checkbox');
          swatch.setAttribute('aria-checked', String(swatch.classList.contains('po-imageOption-checked')));
          swatch.setAttribute('aria-label', item?.textContent.trim() || labels.agPackaging);
          swatch.tabIndex = 0;
          if (!swatch.dataset.agKeyboard) {
            swatch.dataset.agKeyboard = 'true';
            swatch.addEventListener('keydown', event => {
              if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); swatch.click(); }
            });
          }
        });
        let toggle = option.querySelector('.ag-packaging-toggle');
        if (!toggle) {
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'ag-packaging-toggle';
          toggle.setAttribute('aria-expanded', 'false');
          grid.id = grid.id || root.id + '-packaging';
          toggle.setAttribute('aria-controls', grid.id);
          toggle.append(document.createElement('strong'), document.createElement('span'));
          grid.before(toggle);
          toggle.addEventListener('click', () => {
            const open = option.classList.toggle('ag-packaging-open');
            toggle.setAttribute('aria-expanded', String(open));
            sync();
          });
        }
        const selected = option.querySelector('.po-label-selectedValues')?.textContent.trim() || field.value;
        const title = !selected || (/gratuit/i.test(selected) && !selected.includes(',')) ? labels.agIncluded : labels.agPackaging + ': ' + selected;
        if (toggle.querySelector('strong').textContent !== title) toggle.querySelector('strong').textContent = title;
        const action = option.classList.contains('ag-packaging-open') ? labels.agCollapse : labels.agExpand;
        if (toggle.querySelector('span').textContent !== action) toggle.querySelector('span').textContent = action;
      });
    };
    button.addEventListener('click', () => {
      const buy = actualButton();
      if (!buy || buy.disabled) return;
      const invalid = Array.from(root.querySelectorAll('input[required],select[required],textarea[required]')).find(input => !input.disabled && !input.checkValidity());
      if (invalid) {
        invalid.closest('.po-option-root')?.classList.add('ag-packaging-open');
        invalid.scrollIntoView({behavior:'smooth',block:'center'});
        invalid.focus({preventScroll:true});
        invalid.reportValidity();
        return;
      }
      buy.click();
      const error = root.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (error) error.scrollIntoView({behavior:'smooth',block:'center'});
    });
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    });
    observer.observe(info, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    root.addEventListener('change', sync);
    sync();
  };
  const init = () => document.querySelectorAll('[data-ag-product-layout]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

